import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './App.css';
import './components/General/AdminListCard.css';
import './styles/filter-panels.css';
import './template/mini-sidebar/scss/style.scss';
import 'react-toastify/dist/ReactToastify.css';
import './styles/toastify-app-theme.css';
import 'bootstrap/dist/css/bootstrap.css';

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();